import { PickListItem, JsonItem } from "../list-management.objects"; 
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

export class UserPermissionSelctor implements SpecialCaseEntity {
    id: string;
    propertyName: string;
    permissionPickListName: string;
    isNew: boolean;

    permissionPickList: PickListItem[];

    isRequired: boolean;
    displayName: string;

    initialPermissions: string[];
    addedPermissions: string[];

    permissionNameMap: Map<string, string> = new Map<string, string>();
    descriptionMap: Map<string, string> = new Map<string, string>();
    ignorePermissions: string[];

    storedValues: string[][] = [];

    constructor(id: string, propteryName: string, permissionListName: string, displayName: string, isRequired: boolean, isNew: boolean) {
        this.id = id;
        this.propertyName = propteryName;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.isNew = isNew;

        this.permissionPickListName = permissionListName;

        this.permissionNameMap.set("Admin", "Portal Admin");
        this.permissionNameMap.set("General", "General Access");
        this.permissionNameMap.set("Steering-Committee", "Steering Committee");
        this.permissionNameMap.set("Project-Manager", "Program Manager");
        this.permissionNameMap.set("Oversight", "Oversight - View/Edit All")
        //this.permissionNameMap.set("CDSC-SAB", "CDSC Scientific Advisory Board");
        this.permissionNameMap.set("View-All-Deliverables", "View All Deliverables");

        this.descriptionMap.set("Admin", "Portal Admins will have full access to every page and feature available on the portal.");
        this.descriptionMap.set("General", "General Access is the base level permission for the ReVAMPP private portal. Users with this permission will have access to any pages or features on the private portal that don't have their own specified permission (Ex: User Directory, Home page).")
        this.descriptionMap.set("Steering-Committee", "Having this role will grant the user access to the Network Steering Committee page.")
        this.descriptionMap.set("Project-Manager", "This role grants access to the PM Dashboard. Use additional 'PM' dropdowns to specify the centers this person will be able to manage.")

        //this.descriptionMap.set("CDSC-SAB", "This role grants access to the CDSC Scientific Advisory Board page."),
        this.descriptionMap.set("View-All-Deliverables", "This role allows the user the view deliverables from every center on the Deliverables Tracker page.")
        this.descriptionMap.set("Oversight", "This role will give the user access to the PM Dashboard for all centers, and allow them to view/edit any records submitted to the ReVAMPP Portal (e.g., Deliverables, Manuscripts, Animal Models).")

        this.ignorePermissions = ["Steering-Committee", "CDSC-SAB", "View-All-Deliverables"]
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";
        let html = `
            <div class="user-permissions-section" id="${this.id}">
                
            </div>
        `;
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.permissionPickList = [];
        let foundPermissionList = pickLists.find(list => list.Id == this.permissionPickListName);

        if (!foundPermissionList) return;

        this.permissionPickList = foundPermissionList.Json;
        // Ignore Permissions
        this.permissionPickList = this.permissionPickList.filter(item => !this.ignorePermissions.includes(item.Value));

        let size = "";
        if (this.isNew) size = "col-lg-5";

        // Dropdown Html
        let addedHtml = ""
        this.permissionPickList.forEach(permission => {
            let labelName = permission.Value;
            if (this.permissionNameMap.has(permission.Value)) {
                labelName = this.permissionNameMap.get(permission.Value);
            }

            let description = "";
            if (this.descriptionMap.has(permission.Value)) {
                description = this.descriptionMap.get(permission.Value);
            }

            addedHtml += `
                <div id="permission-selector-container" class="mb-3 col-12 ${size} px-0">
                    <label for="">${labelName}</label>
                    ${description != "" ? `<p class='form-text mb-1 mt-0'>${description}</p>` : ``}
                    <select id="permission-select-${permission.Id.toString()}-${this.id}" class="selectpicker dropdown list-management-dropdown" title="None Selected" data-width="100%" data-container="body" data-dropup-auto="false" data-size="5"></select>
                </div>
            `
        });
        $(`#${this.id}`).empty().html(addedHtml);

        this.permissionPickList.forEach(permission => {
            this.generateDropdown(`permission-select-${permission.Id.toString()}-${this.id}`);
        });
    }
    getCurrentPermissionArr(index: number): string[] {
        return this.storedValues[index];
    }

    getValue(): any {
        let permissionsSelected = [];
        this.permissionPickList.forEach(permission => {
            if ($(`#permission-select-${permission.Id.toString()}-${this.id}`).val() == "1") {
                permissionsSelected.push(permission.Value);
            }
        });

        this.addedPermissions = permissionsSelected;

        return this.addedPermissions;
    }

    getRemovedPermissions(): string[] {
        let removedPermissions = [];
        this.permissionPickList.forEach(permission => {
            if ($(`#permission-select-${permission.Id.toString()}-${this.id}`).val() == "0") {
                removedPermissions.push(permission.Value);
            }
        });

        return removedPermissions;
    }

    getUnspecified(): string[] {
        let unspecifiedPermissions = [];
        this.permissionPickList.forEach(permission => {
            if ($(`#permission-select-${permission.Id.toString()}-${this.id}`).val() == "") {
                unspecifiedPermissions.push(permission.Value);
            }
        });

        return unspecifiedPermissions;
    }

    validate(): boolean {
        return true;
    }

    getDisplayPermission(permissionId: number): string {
        let returnVal = "";
        let foundPermission = this.permissionPickList.find(permission => permission.Id == permissionId);
        if (foundPermission) {
            returnVal = foundPermission.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        this.storedValues = [];
        entityArray.forEach(entity => {
            this.storedValues.push(_.get(entity, this.propertyName));
        })

        this.permissionPickList.forEach(permission => {
            if (this.storedValues.every((val, i, arr) => val.includes(permission.Value))) {
                $(`#permission-select-${permission.Id.toString()}-${this.id}`).selectpicker("val", "1");
            }
            else if (this.storedValues.every((val, i, arr) => !val.includes(permission.Value))) {
                $(`#permission-select-${permission.Id.toString()}-${this.id}`).selectpicker("val", "0");
            }
            else {
                $(`#permission-select-${permission.Id.toString()}-${this.id}`).selectpicker("val", "");
            }
        });
    }

    checkChanged(): boolean {
        return true;
    }

    // Yes/No
    generateDropdown(dropdownId: string): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        $(`#${dropdownId}`).append(new Option("Yes", "1", false, false));
        $(`#${dropdownId}`).append(new Option("No", "0", false, true));

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getCurrentDisplayValue(indexVal): string {
        let permissionArr: string[] = [];
        let currentPermissions = this.storedValues[indexVal];
        let addedPermissions: string[] = this.getValue();
        let unspecifiedPermissions: string[] = this.getUnspecified();

        let returnPermissions: string[] = [...addedPermissions];
        currentPermissions.forEach(permission => {
            if (unspecifiedPermissions.includes(permission)) {
                returnPermissions.push(permission);
            }
        });

        permissionArr = returnPermissions;

        let listItems = "";
        permissionArr.forEach(permission => {
            listItems += `<li>${permission}</li>`;
        })

        let returnHtml = `
            <ul class="mb-0">
                ${listItems}
            </ul>
        `;

        return returnHtml;
    }

    getPreviousDisplayValue(indexVal): string {
        let permissionArr: string[] = this.storedValues[indexVal];

        let listItems = "";
        permissionArr.forEach(permission => {
            listItems += `<li>${permission}</li>`;
        })

        let returnHtml = `
            <ul>
                ${listItems}
            </ul>
        `;

        return returnHtml;
    }
}